import type { KeyboardShortcut } from './../ricos-types';
import { createShortcut } from './../ricos-types';

const command: KeyboardShortcut['command'] = ({ event }) => {
  event?.preventDefault();
};

export const generalShortcuts: KeyboardShortcut[] = [
  createShortcut({
    name: 'AddHorizontalTabulation',
    description: 'ShortcutsSheet_General_AddHorizontalTabulation',
    group: 'ShortcutsSheet_Section_General',
    keys: {
      macOs: 'Tab',
      windows: 'Tab',
    },
    enabled: true,
    command: ({ publicCommands, event }) => {
      const selection = publicCommands.getSelection();

      if (selection.isFocused) {
        event?.preventDefault();
      }

      return true;
    },
  }),
  createShortcut({
    name: 'SelectPrevBlock',
    description: 'ShortcutsSheet_General_SelectThePreviousBlock',
    group: 'ShortcutsSheet_Section_General',
    keys: {
      macOs: 'Shift+Tab',
      windows: 'Shift+Tab',
    },
    enabled: false,
    command,
  }),
  createShortcut({
    name: 'MoveSelectionThroughElements',
    description: 'ShortcutsSheet_General_MoveSelectionThroughAllElements',
    group: 'ShortcutsSheet_Section_General',
    keys: {
      macOs: 'Arrow',
      windows: 'Arrow',
    },
    enabled: false,
    command,
  }),
  createShortcut({
    name: 'OpenBlocksMenu',
    description: 'ShortcutsSheet_General_OpenBlocksMenu',
    group: 'ShortcutsSheet_Section_General',
    keys: {
      macOs: 'Meta+Shift+P',
      windows: 'Ctrl+Shift+P',
    },
    enabled: false,
    command,
  }),
  createShortcut({
    name: 'SelectAll',
    description: 'ShortcutsSheet_General_SelectAll',
    group: 'ShortcutsSheet_Section_General',
    keys: {
      macOs: 'Meta+A',
      windows: 'Ctrl+A',
    },
    enabled: false,
    command,
  }),
  createShortcut({
    name: 'SelectTextBlocks',
    description: 'ShortcutsSheet_General_SelectTextBlocks',
    group: 'ShortcutsSheet_Section_General',
    keys: {
      macOs: 'Shift+Arrow',
      windows: 'Shift+Arrow',
    },
    enabled: false,
    command,
  }),
  createShortcut({
    name: 'ClearSelection',
    description: 'ShortcutsSheet_General_ClearSelection',
    group: 'ShortcutsSheet_Section_General',
    keys: {
      macOs: 'Escape',
      windows: 'Escape',
    },
    enabled: false,
    command,
  }),
  createShortcut({
    name: 'MoveSelectedBlockUp',
    description: 'ShortcutsSheet_General_MoveSelectedBlockUp',
    group: 'ShortcutsSheet_Section_General',
    keys: {
      macOs: 'Meta+Shift+ArrowUp',
      windows: 'Ctrl+Shift+ArrowUp',
    },
    enabled: false,
    command,
  }),
  createShortcut({
    name: 'MoveSelectedBlockDown',
    description: 'ShortcutsSheet_General_MoveSelectedBlockDown',
    group: 'ShortcutsSheet_Section_General',
    keys: {
      macOs: 'Meta+Shift+ArrowDown',
      windows: 'Ctrl+Shift+ArrowDown',
    },
    enabled: false,
    command,
  }),
  createShortcut({
    name: 'PasteWithoutFormatting',
    description: 'ShortcutsSheet_Formatting_PasteWithoutFormatting',
    group: 'ShortcutsSheet_Section_Formatting',
    keys: {
      macOs: 'Meta+Shift+V',
      windows: 'Ctrl+Shift+V',
    },
    enabled: false,
    command,
  }),
];
